import React, { useState, useEffect } from 'react'
import DraggableModal from '../../../generic/DraggableModal'
import { backendPatchWithoutRefresh } from '../../../../helpers/callBackend'
import { DwollaBusinessVCR, DwollaBeneficialOwners, useDwollaWeb } from '@dwolla/react-drop-ins'
import { message } from 'antd'
import Stack from '@mui/material/Stack'
import { ARPARI_ENV, createUrl } from '../../../../helpers/axios'


const EntityPaymentsApplicationModal = ({
  visible,
  handleCancelModal,
  entityId,
  setCustomerId,
  customer,
  setCustomer,
  setCustomerObjectVerified,
}) => {
  // get dwollaEnv with override possible
  const dwollaEnv = ARPARI_ENV === 'PROD' ? 'production' : 'sandbox';

  const dwollaTokenUrl = createUrl('/api/arpari-dwolla/token/')
  const [certifyBeneficialOwnership, setCertifyBeneficialOwnership] = useState(false)
  const handleSuccess = async (success) => {
    const errors = success.response?._embedded?.errors
    if (errors) {
      // errors from dwolla
      // add 'else if' statements for specific error handling where we want
      const err = errors[0]
      let message = err.message
      if (err.path == '/correlationId') {
        message = 'Entity has already been submitted for payments approval'
      }
      message.error(message)
      // handleCancelModal(false); // set modal invisible
      return
    }

    const entityPatch = await backendPatchWithoutRefresh('/api/arpari-dwolla/customer/', {
      entity_id: entityId,
      response: success.response,
      resource: success.resource,
    })

    if (entityPatch.status == 200) {
      // TODO: update table information
      setCustomerId(entityPatch.data?.data?.id)
    }

    if (success.response.hasOwnProperty('_links')) {
      // updated object, if customer check if we need to mark as verified
      if (!success.response._links?.self?.hasOwnProperty('resource-type')) {
        return
      }
      if (success.response._links.self['resource-type'] == 'customer') {
        // customer object was updated and returned
        setCustomer(success.response)
        if (
          success.response.status == 'verified' &&
          !success.response._links.hasOwnProperty('certify-beneficial-ownership')
        ) {
          // verified and beneficial owners certified
          setCustomerObjectVerified(true)
        }
      }
    }
  }

  const handleError = async (err) => {
    handleCancelModal(false) // set modal invisible
    message.error(err)
  }

  const dwollaConfig = {
    environment: dwollaEnv,
    styles: '/styles/dwolla.css',
    onError: (err) => {
      handleError(err)
    },
    onSuccess: (resp) => {
      handleSuccess(resp)
    },
    tokenUrl: dwollaTokenUrl,
  }

  const { ready, error } = useDwollaWeb(dwollaConfig)

  useEffect(() => {
    if ('_links' in customer) {
      if ('certify-beneficial-ownership' in customer._links) {
        setCertifyBeneficialOwnership(true)
      } else {
        setCertifyBeneficialOwnership(false)
      }
    }
  }, [customer])

  if (!ready) return <></>

  if (error) return <></>

  return (
    <DraggableModal
      width='740px'
      modalTitle='Apply'
      modalVisible={visible}
      handleCancelModal={handleCancelModal}
      content={
        <Stack spacing={1}>
          {customer?.status != 'verified' && (
            <DwollaBusinessVCR
              customerId={customer?.id}
              privacy='https://www.arpari.com/legal/privacy-policy'
              terms='https://www.arpari.com/legal/terms-of-service'
            />
          )}
          {certifyBeneficialOwnership && <DwollaBeneficialOwners customerId={customer?.id} />}
        </Stack>
      }
    />
  )
}

export default EntityPaymentsApplicationModal
